import { Component, computed, input } from "@angular/core";
import { sanitizeDirectusArray } from "../../../../common/utils/sanitize-directus-object";
import { AdTypes } from "../../../api/common/model-enums/ad-types.enum";
import { Files } from "../../../api/packbo/models/files";
import { ItemsAdBlock } from "../../../api/packbo/models/items-ad-block";
import { ItemsAds } from "../../../api/packbo/models/items-ads";
import { AdCarouselComponent, AdCarouselType } from "./components/ad-carousel/ad-carousel.component";

@Component({
    selector: "packbo-ad-block",
    templateUrl: "./ad-block.template.html",
    imports: [AdCarouselComponent]
})
export class AdBlockComponent {
    public readonly adBlock = input.required<ItemsAdBlock>();
    public readonly ads = computed(() => {
        const adsRefs = sanitizeDirectusArray(this.adBlock()?.ads_refs);
        if (!adsRefs) {
            return [];
        }
        return adsRefs.map((ref) => {
            const ad = ref.ads_id as ItemsAds;
            return {
                ...ad,
                image: ad.image as Files
            };
        });
    });

    public readonly AdTypes = AdTypes;
    public readonly AdCarouselType = AdCarouselType;
}
